import { detect } from 'detect-browser';

import type { NetworkInformation } from '@shared-types/global.types';
import { EffectiveConnectionType } from '@shared-types/global.types';

/**
 * Always reads <html lang> fresh to avoid stale values when the
 * attribute is set asynchronously after module load.
 */
export const getLanguage = (): string => document.documentElement?.lang?.trim() || 'en';

/**
 * @deprecated Captured at module load time and may be stale if <html lang>
 * is set asynchronously. Prefer `getLanguage()` for accurate values.
 */
export const language = getLanguage();

export const culture = document.querySelector('html').dataset.culture || 'en-GB';

//define variable if you want always log enabled
//check in querystring & cookies
export const IS_DEBUG = /isdebug/i.test(document.location.search);

export const CMP_IMPORT = /cmpimport/i.test(document.location.hash);

//define variable to activate mock behaviours
export const IS_SIMULATION = /issimulation/i.test(document.location.search);

//define variable if you want enabled manual inject of mock api
export const IS_TEST = /istest/i.test(document.location.search);

//define variabile if you want that refresh time ignores match status
export const FORCE_REFRESH = /forceRefresh/i.test(document.location.search);

let _IS_MOBILE = false;
// check for mobile useragent
if (/forceMobile=true/i.test(document.location.search)) _IS_MOBILE = true;
else if (/forceMobile=false/i.test(document.location.search)) _IS_MOBILE = false;
else
  _IS_MOBILE = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet/i.test(
    window.navigator.userAgent,
  );

export const IS_MOBILE = _IS_MOBILE;

declare const navigator: Navigator & {
  connection?: NetworkInformation;
  mozConnection?: NetworkInformation;
  webkitConnection?: NetworkInformation;
};

const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
export let IS_BAD_NETWORK_DETECTED: boolean;

function updateConnectionStatus() {
  IS_BAD_NETWORK_DETECTED = (
    [EffectiveConnectionType['slow-2g'], EffectiveConnectionType['2g']] as EffectiveConnectionType[]
  ).includes(connection?.effectiveType);
}

connection?.addEventListener('change', updateConnectionStatus);
updateConnectionStatus();

export function navigatorShareAvailable() {
  const browser = detect();
  if (!browser) return false;
  return ['iOS', 'Android OS'].includes(browser.os) && !!window.navigator.share;
}
